import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as customAPI from '../../lib/api/customapi';
import { takeLatest } from 'redux-saga/effects';

/**
 * API 서버에 Request 하는 Action Type
 */
const [
    REQ_TYPE_ADD_CONSULT,
    REQ_TYPE_ADD_CONSULT_SUCCESS,
    REQ_TYPE_ADD_CONSULT_FAILURE,
] = createRequestActionTypes('customservice/ADD_CONSULT');

const [
    REQ_TYPE_GET_CONSULT,
    REQ_TYPE_GET_CONSULT_SUCCESS,
    REQ_TYPE_GET_CONSULT_FAILURE,
] = createRequestActionTypes('customservice/GET_CONSULT');

const [
    REQ_TYPE_GET_NOTICE,
    REQ_TYPE_GET_NOTICE_SUCCESS,
    REQ_TYPE_GET_NOTICE_FAILURE,
] = createRequestActionTypes('customservice/GET_NOTICE');

const [
    REQ_TYPE_GET_FAQ,
    REQ_TYPE_GET_FAQ_SUCCESS,
    REQ_TYPE_GET_FAQ_FAILURE,
] = createRequestActionTypes('customservice/GET_FAQ');

const [
    REQ_TYPE_GET_POPUP,
    REQ_TYPE_GET_POPUP_SUCCESS,
    REQ_TYPE_GET_POPUP_FAILURE,
] = createRequestActionTypes('customservice/GET_POPUP');


const SET_ADD_CONSULT_RESULT_RESET = 'customservice/SET_ADD_CONSULT_RESULT_RESET';

export const addConsultAction = createAction(REQ_TYPE_ADD_CONSULT, (formData) => {
    return { formData }
});
export const setAddConsultResultResetAction = createAction(SET_ADD_CONSULT_RESULT_RESET);
export const getConsultAction = createAction(REQ_TYPE_GET_CONSULT, (user_email, curPage) => {
    return { user_email, curPage }
});
export const getNoticeAction = createAction(REQ_TYPE_GET_NOTICE, (ntc_type, curPage) => {
    return { ntc_type, curPage }
});

export const getFaqAction = createAction(REQ_TYPE_GET_FAQ, (faq_type, curPage) => {
    return { faq_type, curPage }
});

export const getPopUpAction = createAction(REQ_TYPE_GET_POPUP);

/**
 * SAGA API 에서 REST API 호출 
 */
const addConsultSaga = createRequestSaga(REQ_TYPE_ADD_CONSULT, customAPI.addConsult);
const getConsultSaga = createRequestSaga(REQ_TYPE_GET_CONSULT, customAPI.getConsult);
const getNoticeSaga = createRequestSaga(REQ_TYPE_GET_NOTICE, customAPI.getNotice);
const getFaqSaga = createRequestSaga(REQ_TYPE_GET_FAQ, customAPI.getFaq);
const getPopupSaga = createRequestSaga(REQ_TYPE_GET_POPUP, customAPI.getPopUp);

export function* customserviceSaga() {
    yield takeLatest(REQ_TYPE_ADD_CONSULT, addConsultSaga);
    yield takeLatest(REQ_TYPE_GET_CONSULT, getConsultSaga);
    yield takeLatest(REQ_TYPE_GET_NOTICE, getNoticeSaga);
    yield takeLatest(REQ_TYPE_GET_FAQ, getFaqSaga);
    yield takeLatest(REQ_TYPE_GET_POPUP, getPopupSaga);
}


/**
 * Store에 저장될 값 
 */
const initialState = {
    resultAddConsult: null,
    listData: null,

    popUpData: null,
    error: null
}

const customserviceReducer = handleActions(
    {
        [REQ_TYPE_ADD_CONSULT_SUCCESS]: (state, { payload: resultAddConsult }) => {
            //console.log("success : " + JSON.stringify(resultAddConsult));
            return ({
                ...state,
                error: null,
                resultAddConsult: resultAddConsult,
            })
        },
        [REQ_TYPE_ADD_CONSULT_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
                resultAddConsult: error,
            })
        },
        [REQ_TYPE_GET_CONSULT_SUCCESS]: (state, { payload: listData }) => {
            //console.log("success : " + JSON.stringify(listData));
            return ({
                ...state,
                error: null,
                listData: listData,
            })
        },
        [REQ_TYPE_GET_CONSULT_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },
        [SET_ADD_CONSULT_RESULT_RESET]: (state) => {

            return ({
                ...state,
                resultAddConsult: null,
            })
        },
        [REQ_TYPE_GET_NOTICE_SUCCESS]: (state, { payload: listData }) => {
            //console.log("success : " + JSON.stringify(listData));
            return ({
                ...state,
                error: null,
                listData: listData,
            })
        },
        [REQ_TYPE_GET_NOTICE_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },
        [REQ_TYPE_GET_FAQ_SUCCESS]: (state, { payload: listData }) => {
            //console.log("success : " + JSON.stringify(listData));
            return ({
                ...state,
                error: null,
                listData: listData,
            })
        },
        [REQ_TYPE_GET_FAQ_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },
        [REQ_TYPE_GET_POPUP_SUCCESS]: (state, { payload: popUpData }) => {
            //console.log("success : " + JSON.stringify(listData));
            return ({
                ...state,
                error: null,
                popUpData: popUpData,
            })
        },
        [REQ_TYPE_GET_POPUP_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
                popUpData: null,
            })
        },
    }
    , initialState);

export default customserviceReducer;
